<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";

defineProps({
  member: {
    type: Object,
    required: true,
  },
  showBioModal: Boolean
});
defineEmits(["close"]);
</script>


<template>

  <CustomModal
      :show="showBioModal"
      classes="w-1/6"
      :custom-index="40"
      extra-classes="h-fit !overflow-visible"
      drawerHeight="'100%'"
  >

    <div class="relative sm:min-w-[200px] md:min-w-[400px]">
      <!-- Desktop -->
      <div
          class="hidden sm:flex absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white border border-gray-300 rounded-full w-10 h-10 items-center justify-center shadow-md cursor-pointer"
          @click="$emit('close')"
      >
        ✕
      </div>

      <!-- Mobile -->
      <div
          class="flex sm:hidden absolute right-3 top-3 transform -translate-x-1/2 bg-white border border-gray-300 rounded-full w-10 h-10 items-center justify-center shadow-md cursor-pointer"
          @click="$emit('close')"
      >
        ✕
      </div>
      <div class="bg-white rounded-xl max-w-4xl w-full p-12 flex flex-col sm:flex-row gap-12 ">
        <!-- Left: Image + name + title -->
        <div class="flex flex-col items-center text-center gap-4 min-w-[200px]">
          <img
              :src="member.image"
              alt="Profile Image"
              class="w-44 h-44 rounded-full object-cover border-4 border-primary-violet"
          />
          <div>
            <div class="responsive-body-large font-semibold text-primary-darkBlue">
              {{ member.name }}
            </div>
            <p class="text-[#BEA5AA] responsive-body-small whitespace-nowrap">
              {{ member.title }}
            </p>
          </div>
        </div>
        <!-- Right: Bio -->
        <div class="flex flex-col h-full text-primary-darkBlue">
          <div class="responsive-title-4 font-bold pb-4">About {{ member.name }}</div>

          <div class="flex flex-col gap-4 pr-2 overflow-y-auto max-h-[260px] sm:max-h-[200px] scroll-indicator">
            <p class="responsive-body-medium">
              {{ member.bio }}
            </p>
          </div>

        </div>

      </div>
    </div>
<!--    </div>-->
  </CustomModal>
</template>

<style scoped>

</style>
